import { AnimatePresence, motion } from "framer-motion";
import type { IconType } from "react-icons";
import FileListItem from "./FileListItem";
import type { ConverterTheme, FileSetter } from "./types";

interface FileQueuePanelProps {
  files: File[];
  setFiles: FileSetter;
  isConverting: boolean;
  icon: IconType;
  getFileExtension: (filename: string) => string;
  formatBytes: (bytes: number) => string;
  badgeClassForExt: (ext: string) => string;
  theme: ConverterTheme;
}

const FileQueuePanel = ({
  files,
  setFiles,
  isConverting,
  icon,
  getFileExtension,
  formatBytes,
  badgeClassForExt,
  theme,
}: FileQueuePanelProps) => {
  const removeFile = (index: number) =>
    setFiles((prev) => prev.filter((_, i) => i !== index));

  return (
    <div className="glass rounded-3xl p-5 shadow-xl md:p-6">
      <h3 className="mb-4 text-sm font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400">
        Queue · {files.length} file{files.length > 1 ? "s" : ""}
      </h3>
      <div className="max-h-[340px] space-y-2 overflow-y-auto pr-1">
        <AnimatePresence initial={false}>
          {files.map((file, index) => (
            <motion.div
              key={`${file.name}-${file.size}`}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
            >
              <FileListItem
                file={file}
                onRemove={isConverting ? null : () => removeFile(index)}
                icon={icon}
                getFileExtension={getFileExtension}
                formatBytes={formatBytes}
                badgeClassForExt={badgeClassForExt}
                theme={theme}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FileQueuePanel;
